module.exports = __webpack_public_path__ + "img/near_cyl75_axis90.c055d794.jpg";